import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()(() => ({
  betaTag: {
    borderRadius: "4px",
    color: "var(--color-blue-700) !important",
    backgroundColor: "var(--color-blue-200) !important",
    fontSize: "10px !important",
    fontWeight: "600",
    border: "none",
    height: "auto",
    ".MuiChip-label": {
      padding: "4px !important",
    },
  },
}));
